import { AnimatorSchema } from './Animator.gen';
import { AudioSourceSchema } from './AudioSource.gen';
import { AudioStreamSchema } from './AudioStream.gen';
import { AvatarAttachSchema } from './AvatarAttach.gen';
import { AvatarModifierAreaSchema } from './AvatarModifierArea.gen';
import { AvatarShapeSchema } from './AvatarShape.gen';
import { BillboardSchema } from './Billboard.gen';
import { CameraModeSchema } from './CameraMode.gen';
import { CameraModeAreaSchema } from './CameraModeArea.gen';
import { EngineInfoSchema } from './EngineInfo.gen';
import { GltfContainerSchema } from './GltfContainer.gen';
import { GltfContainerLoadingStateSchema } from './GltfContainerLoadingState.gen';
import { MaterialSchema } from './Material.gen';
import { MeshColliderSchema } from './MeshCollider.gen';
import { MeshRendererSchema } from './MeshRenderer.gen';
import { NftShapeSchema } from './NftShape.gen';
import { PointerEventsSchema } from './PointerEvents.gen';
import { PointerEventsResultSchema } from './PointerEventsResult.gen';
import { PointerLockSchema } from './PointerLock.gen';
import { RaycastSchema } from './Raycast.gen';
import { RaycastResultSchema } from './RaycastResult.gen';
import { TextShapeSchema } from './TextShape.gen';
import { TweenSchema } from './Tween.gen';
import { TweenSequenceSchema } from './TweenSequence.gen';
import { TweenStateSchema } from './TweenState.gen';
import { UiBackgroundSchema } from './UiBackground.gen';
import { UiCanvasInformationSchema } from './UiCanvasInformation.gen';
import { UiDropdownSchema } from './UiDropdown.gen';
import { UiDropdownResultSchema } from './UiDropdownResult.gen';
import { UiInputSchema } from './UiInput.gen';
import { UiInputResultSchema } from './UiInputResult.gen';
import { UiTextSchema } from './UiText.gen';
import { UiTransformSchema } from './UiTransform.gen';
import { VideoEventSchema } from './VideoEvent.gen';
import { VideoPlayerSchema } from './VideoPlayer.gen';
import { VisibilityComponentSchema } from './VisibilityComponent.gen';
export * from './pb/decentraland/sdk/components/animator.gen';
export * from './pb/decentraland/sdk/components/audio_source.gen';
export * from './pb/decentraland/sdk/components/audio_stream.gen';
export * from './pb/decentraland/sdk/components/avatar_attach.gen';
export * from './pb/decentraland/sdk/components/avatar_modifier_area.gen';
export * from './pb/decentraland/sdk/components/avatar_shape.gen';
export * from './pb/decentraland/sdk/components/billboard.gen';
export * from './pb/decentraland/sdk/components/camera_mode.gen';
export * from './pb/decentraland/sdk/components/camera_mode_area.gen';
export * from './pb/decentraland/sdk/components/engine_info.gen';
export * from './pb/decentraland/sdk/components/gltf_container.gen';
export * from './pb/decentraland/sdk/components/gltf_container_loading_state.gen';
export * from './pb/decentraland/sdk/components/material.gen';
export * from './pb/decentraland/sdk/components/mesh_collider.gen';
export * from './pb/decentraland/sdk/components/mesh_renderer.gen';
export * from './pb/decentraland/sdk/components/nft_shape.gen';
export * from './pb/decentraland/sdk/components/pointer_events.gen';
export * from './pb/decentraland/sdk/components/pointer_events_result.gen';
export * from './pb/decentraland/sdk/components/pointer_lock.gen';
export * from './pb/decentraland/sdk/components/raycast.gen';
export * from './pb/decentraland/sdk/components/raycast_result.gen';
export * from './pb/decentraland/sdk/components/text_shape.gen';
export * from './pb/decentraland/sdk/components/tween.gen';
export * from './pb/decentraland/sdk/components/tween_sequence.gen';
export * from './pb/decentraland/sdk/components/tween_state.gen';
export * from './pb/decentraland/sdk/components/ui_background.gen';
export * from './pb/decentraland/sdk/components/ui_canvas_information.gen';
export * from './pb/decentraland/sdk/components/ui_dropdown.gen';
export * from './pb/decentraland/sdk/components/ui_dropdown_result.gen';
export * from './pb/decentraland/sdk/components/ui_input.gen';
export * from './pb/decentraland/sdk/components/ui_input_result.gen';
export * from './pb/decentraland/sdk/components/ui_text.gen';
export * from './pb/decentraland/sdk/components/ui_transform.gen';
export * from './pb/decentraland/sdk/components/video_event.gen';
export * from './pb/decentraland/sdk/components/video_player.gen';
export * from './pb/decentraland/sdk/components/visibility_component.gen';
/** @public */ export const Animator = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::Animator", AnimatorSchema);
/** @public */ export const AudioSource = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::AudioSource", AudioSourceSchema);
/** @public */ export const AudioStream = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::AudioStream", AudioStreamSchema);
/** @public */ export const AvatarAttach = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::AvatarAttach", AvatarAttachSchema);
/** @public */ export const AvatarModifierArea = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::AvatarModifierArea", AvatarModifierAreaSchema);
/** @public */ export const AvatarShape = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::AvatarShape", AvatarShapeSchema);
/** @public */ export const Billboard = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::Billboard", BillboardSchema);
/** @public */ export const CameraMode = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::CameraMode", CameraModeSchema);
/** @public */ export const CameraModeArea = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::CameraModeArea", CameraModeAreaSchema);
/** @public */ export const EngineInfo = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::EngineInfo", EngineInfoSchema);
/** @public */ export const GltfContainer = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::GltfContainer", GltfContainerSchema);
/** @public */ export const GltfContainerLoadingState = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::GltfContainerLoadingState", GltfContainerLoadingStateSchema);
/** @public */ export const Material = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::Material", MaterialSchema);
/** @public */ export const MeshCollider = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::MeshCollider", MeshColliderSchema);
/** @public */ export const MeshRenderer = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::MeshRenderer", MeshRendererSchema);
/** @public */ export const NftShape = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::NftShape", NftShapeSchema);
/** @public */ export const PointerEvents = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::PointerEvents", PointerEventsSchema);
/** @public */ export const PointerEventsResult = (engine) => /* @__PURE__ */ engine.defineValueSetComponentFromSchema("core::PointerEventsResult", PointerEventsResultSchema, {
    timestampFunction: (t) => t.timestamp,
    maxElements: 100
});
/** @public */ export const PointerLock = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::PointerLock", PointerLockSchema);
/** @public */ export const Raycast = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::Raycast", RaycastSchema);
/** @public */ export const RaycastResult = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::RaycastResult", RaycastResultSchema);
/** @public */ export const TextShape = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::TextShape", TextShapeSchema);
/** @public */ export const Tween = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::Tween", TweenSchema);
/** @public */ export const TweenSequence = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::TweenSequence", TweenSequenceSchema);
/** @public */ export const TweenState = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::TweenState", TweenStateSchema);
/** @public */ export const UiBackground = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiBackground", UiBackgroundSchema);
/** @public */ export const UiCanvasInformation = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiCanvasInformation", UiCanvasInformationSchema);
/** @public */ export const UiDropdown = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiDropdown", UiDropdownSchema);
/** @public */ export const UiDropdownResult = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiDropdownResult", UiDropdownResultSchema);
/** @public */ export const UiInput = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiInput", UiInputSchema);
/** @public */ export const UiInputResult = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiInputResult", UiInputResultSchema);
/** @public */ export const UiText = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiText", UiTextSchema);
/** @public */ export const UiTransform = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::UiTransform", UiTransformSchema);
/** @public */ export const VideoEvent = (engine) => /* @__PURE__ */ engine.defineValueSetComponentFromSchema("core::VideoEvent", VideoEventSchema, {
    timestampFunction: (t) => t.timestamp,
    maxElements: 100
});
/** @public */ export const VideoPlayer = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::VideoPlayer", VideoPlayerSchema);
/** @public */ export const VisibilityComponent = engine => 
/* @__PURE__ */ engine.defineComponentFromSchema("core::VisibilityComponent", VisibilityComponentSchema);
/** public */
export const componentDefinitionByName = /* @__PURE__ */ {
    "core::Animator": Animator,
    "core::AudioSource": AudioSource,
    "core::AudioStream": AudioStream,
    "core::AvatarAttach": AvatarAttach,
    "core::AvatarModifierArea": AvatarModifierArea,
    "core::AvatarShape": AvatarShape,
    "core::Billboard": Billboard,
    "core::CameraMode": CameraMode,
    "core::CameraModeArea": CameraModeArea,
    "core::EngineInfo": EngineInfo,
    "core::GltfContainer": GltfContainer,
    "core::GltfContainerLoadingState": GltfContainerLoadingState,
    "core::Material": Material,
    "core::MeshCollider": MeshCollider,
    "core::MeshRenderer": MeshRenderer,
    "core::NftShape": NftShape,
    "core::PointerEvents": PointerEvents,
    "core::PointerEventsResult": PointerEventsResult,
    "core::PointerLock": PointerLock,
    "core::Raycast": Raycast,
    "core::RaycastResult": RaycastResult,
    "core::TextShape": TextShape,
    "core::Tween": Tween,
    "core::TweenSequence": TweenSequence,
    "core::TweenState": TweenState,
    "core::UiBackground": UiBackground,
    "core::UiCanvasInformation": UiCanvasInformation,
    "core::UiDropdown": UiDropdown,
    "core::UiDropdownResult": UiDropdownResult,
    "core::UiInput": UiInput,
    "core::UiInputResult": UiInputResult,
    "core::UiText": UiText,
    "core::UiTransform": UiTransform,
    "core::VideoEvent": VideoEvent,
    "core::VideoPlayer": VideoPlayer,
    "core::VisibilityComponent": VisibilityComponent,
};
